import { IRowPattern } from "../types/IPositionPatterns";
import { ISizeSummary } from "open-vessel-definition";
import { TCG_IN_MMM } from "../consts";
import { createRowsFromConfig } from "../createRowsFromConfig";
import { roundDec } from "@tedivo/tedivo-pure-helpers";

/** Create a set of TCGs to use for missing values */
export function calculateMissingTcgs(
  missingImportantTcgs: boolean,
  sizeSummary: ISizeSummary,
): {
  allRowsTcgs: Record<IRowPattern, number>;
  calcMaxTcg: number | undefined;
  calcMinTcg: number | undefined;
} {
  if (!missingImportantTcgs)
    return {
      allRowsTcgs: {},
      calcMaxTcg: undefined,
      calcMinTcg: undefined,
    };

  const rows = createRowsFromConfig(!!sizeSummary.centerLineRow, sizeSummary.maxRow);

  let calcMinTcg = Infinity;
  let calcMaxTcg = -Infinity;

  const iRows = rows.map(Number);
  const maxRow = Math.max(...iRows);
  const minRow = Math.min(...iRows);

  const minIntTcg = -(maxRow - minRow) * 0.5 * TCG_IN_MMM;
  const allRowsTcgs = rows.reduce((acc, t, idx) => {
    acc[t] = roundDec(idx * TCG_IN_MMM + minIntTcg, 2);
    if (calcMinTcg > acc[t]) calcMinTcg = acc[t];
    if (calcMaxTcg < acc[t]) calcMaxTcg = acc[t];
    return acc;
  }, {} as { [t: IRowPattern]: number });

  return { allRowsTcgs, calcMaxTcg, calcMinTcg };
}
